// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__NFQd6","label":"styles_label__jOC_I","slideInSearchBar":"styles_slideInSearchBar__pEoo_"};